import { useTranslation } from 'react-i18next';
import { HeaderBreadcrumbsProps } from 'src/components/HeaderBreadcrumbs';
import { IdIssuanceManagementList } from '../components/pages/list/components/IdIssuanceManagementList';

export const IdIssuanceManagementPage = () => {
  const { t } = useTranslation();

  const title = t('idIssuanceManagement.pageTitle');
  const breadcrumbs: HeaderBreadcrumbsProps = {
    heading: title,
    links: [{ name: 'TOP', href: '/top' }],
    activeLast: true,
  };
  return <IdIssuanceManagementList pageTitle={title} breadCrumbs={breadcrumbs} />;
};
